import './ContactPage.css';

const ContactPage = () => {

  return (
    <div>
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <h1>Contact Us</h1>
          <p>Let's talk about your data platform needs</p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            {/* Location Map */}
            <div className="contact-map">
              <div className="info-item">
                <h3>📍 Location</h3>
                <p>United Kingdom</p>
                <iframe 
                  title="Loveario Location Map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39127.23034326258!2d0.07878787156365652!3d52.19883492638493!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d85d89f32a012d%3A0x63a320e1a35e3d21!2sCambridge%2C%20UK!5e0!3m2!1sen!2sus!4v1772381254406!5m2!1sen!2sus"
                  width="100%" 
                  height="450" 
                  style={{ border: '0' }}
                  allowFullScreen="" 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>

            {/* Contact Information */}
            <div className="contact-info">
              <div className="info-item">
                <h3>📧 Email</h3>
                <p>
                  <a href="mailto:clintdatagroove@gmail.com">
                    clintdatagroove@gmail.com
                  </a>
                </p>
              </div>

              <div className="info-item">
                <h3>💬 Get In Touch</h3>
                <p>
                  Available for consulting engagements, project-based work
                  and long-term partnerships.
                  <br /><br />
                  We typically respond within 24 hours.
                </p>
              </div>

              <div className="info-item">
                <h3>⏰ Availability</h3>
                <p>
                  Monday – Friday: 9:00 AM – 5:30 PM (GMT)<br />
                  Remote & on-site engagements available
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;